import {LogType} from '../definitions/log-type';
export enum SpecialEventDisplayType {
   Modal,
   Notification
}

export class SpecialEvent {

   constructor(public eventName: string,
               public description: string,
               public buttonText: string,
               public logType: LogType,
               public displayType: SpecialEventDisplayType) {
   }

   public get isModal() {
      return this.displayType == SpecialEventDisplayType.Modal;
   }

   public get isNotification() {
      return this.displayType == SpecialEventDisplayType.Notification;
   }
}



// WEBPACK FOOTER //
// ./src/app/models/messaging/special-event.ts